// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { ErrorAlert } from 'ui_kit_qmd'
import errorIcon from '../../../../images/common/error-icon.svg'
import { useDailyVisit } from '../hooks/useDailyVisit'
import { useMeetingState } from '@daily-co/daily-react'
import { type UseParticipantConnectionStatusesReturnType } from '../hooks/useParticipantConnectionStatuses'
import { useEffect, useState } from 'react'
import { useAutoUpdatingRef } from '@quickmd-llc/frontend-utils'

const getErrorText = (
  { patient, provider }: UseParticipantConnectionStatusesReturnType['participantConnectionStatuses'],
  meetingError: boolean,
) => {
  const patientIssue = patient === 'bad'
  const providerIssue = provider === 'bad'

  if (patientIssue && providerIssue) return 'Connection unstable.'

  if (patientIssue) return 'Your patient is having connection issues.'
  if (providerIssue) return 'Your connection is unstable.'

  if (meetingError) return "We've encountered an error."
  return null
}

export function VisitError() {
  const [errorText, setErrorText] = useState<string | null>(null)
  const { participantConnectionStatuses } = useDailyVisit()

  const meetingError = useMeetingState() === 'error'
  const errorTextRef = useAutoUpdatingRef(errorText)

  useEffect(() => {
    const error = getErrorText(participantConnectionStatuses, meetingError)
    setErrorText(error)
  }, [participantConnectionStatuses, meetingError, errorTextRef])

  if (!errorText) return null
  return (
    <div className='relative z-[1]'>
      <ErrorAlert styleContainer={{ width: 550 }} errorText={errorText} errorImg={errorIcon} imgAlt='Error' />
    </div>
  )
}
